<div class="company-main-page records-page">
    <div class="datatable-page-shell">
        <div class="records-page__hero company-main-hero">
            <div class="records-page__hero-primary">
                <div class="records-page__hero-headline">
                    <span class="records-page__hero-eyebrow">{{ 'COMPANIES' | translate }}</span>
                    <h3 class="records-page__hero-title">{{ 'YOUR_COMPANIES' | translate }}</h3>
                </div>
            </div>
            <div class="records-page__hero-aside">
                <div class="records-page__hero-actions">
                    <ng-select class="saved-search-select" [items]="companySavedSearches" bindLabel="name" bindValue="id"
                        [placeholder]="'SAVED_SEARCHES' | translate" [(ngModel)]="selectedSavedSearchId"
                        (ngModelChange)="onSavedSearchChange($event)" [clearable]="true">
                    </ng-select>
                    <button *ngIf="doWhat.isAdmin || doWhat.canCreate" type="button" class="blue-button" (click)="onAddNew()">{{ 'ADD_COMPANY' | translate }}</button>
                </div>
            </div>
        </div>

        <div class="details-tab-surface company-main-surface datatable-page-surface">
            <app-campaign-datatable class="records-page__table"
                [iShowExport]="false"
                [iCanRead]="doWhat.canRead"
                [iCanWrite]="doWhat.canWrite"
                [iCanDelete]="doWhat.canDelete"
                [iColumns]="columns"
                (oRowClick)="onClientRowClick($event)"
                (oDeleteRows)="deleteRows($event)"
                (oEditRow)="editRow($event)"
                [iData$]="companiesData"></app-campaign-datatable>
        </div>
    </div>
</div>
